<template>
<div class="mMenu-container" :class="{hideMenu: scrollingDown}">
  <div class="space-gap"></div>
  <div class="mHeader-section">
    <div class="mHeader-container">
      <div class="mLogo-container">
        <img
          @click="selectMobileOption('producto') & headerGA4Click('click', 'producto', 'header')"
          :src="icon"
          alt="Logo_Tecate0.0"
        />
      </div>
      <div class="menu">
        <div
          @click="selectMobileOption('producto') & headerGA4Click('click', 'producto', 'header')"
          :class="{ active: getActiveSection === 'producto' }"
          >
            <h2>PRODUCTO</h2>
        </div>
        <div
          @click="selectMobileOption('elaboracion') & headerGA4Click('click', 'elaboracion', 'header')"
          :class="{ active: getActiveSection === 'elaboracion' }"
          >
            <h2>ELABORACIÓN</h2>
        </div>
        <div
          @click="selectMobileOption('ritualdeservido') & headerGA4Click('click', 'ritual del servido', 'header')"
          :class="{ active: getActiveSection === 'ritualdeservido' }"
          >
            <h2>RITUAL DEL SERVIDO</h2>
        </div>
        <div
          @click="selectMobileOption('maridaje') & headerGA4Click('click', 'maridaje', 'header')"
          :class="{ active: getActiveSection === 'maridaje' }"
          >
            <h2>MARIDAJE</h2>
        </div>
        <div
          @click="selectMobileOption('campaign') & headerGA4Click('click', 'campaña', 'header')"
          :class="{ active: getActiveSection === 'campaign' }"
          >
            <h2>CAMPAÑA</h2>
        </div>
        <!-- <div
          @click="selectMacarioOption('macario') & headerGA4Click('click', 'sueña lindo', 'header')"
          :class="{ active: getActiveSection === 'macario' }"
          >
            <h2>SUEÑA LINDO</h2>
        </div> -->
      </div>
      <div class="social-networks" :class="{onlySafari: isSafari}">
        <a
          id="carrito"
          class="social-icon"
          rel="noopener"
          href="javascript:void(0)"
        >
          <img class="iconCarrito" :src="carIconImage" @click="selectMobileOption('retailers') & headerGA4Click('click', 'donde comprar', 'header')"
          :class="{ active: getActiveSection === 'retailers' }" alt="Carrito"/>
        </a>
        <a
          id="facebook"
          class="social-icon"
          target="_blank"
          rel="noopener"
          href="https://www.facebook.com/people/Tecate00/100083628819714/" @click="socialClick('Facebook','Interaction') & socialGA4Click('click', 'redes sociales :: facebook', 'header')"
        >
          <img :src="fbIconImage" alt="Facebook"/>
        </a>
        <a
          id="instagram"
          class="social-icon"
          target="_blank"
          rel="noopener"
          href="https://www.instagram.com/tecate0.0/" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'header')"
        >
          <img :src="inIconImage" alt="Instagram"/>
        </a>
        <a
          id="pinterest"
          class="social-icon"
          target="_blank"
          rel="noopener"
          href="https://www.pinterest.com.mx/Tecate00/" @click="socialClick('Pinterest','Interaction') & socialGA4Click('click', 'redes sociales :: pinterest', 'header')"
        >
          <img :src="pintImage" alt="Pinterest"/>
        </a>
        <a
          id="twitter"
          class="social-icon"
          target="_blank"
          rel="noopener"
          href="https://twitter.com/tecatecerocero" @click="socialClick('Twitter','Interaction') & socialGA4Click('click', 'redes sociales :: twitter', 'header')"
        >
          <img :src="twIconImage" alt="Twitter"/>
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import icon from "@/assets/TECATELOGO.png";
import carIcon from "@/assets/CARRITO.png";
import fbIcon from "@/assets/redes-sociales/FACEBOOK.png";
import inIcon from "@/assets/redes-sociales/INSTAGRAM.png";
import twIcon from "@/assets/redes-sociales/TWITTER.png";
import pintIcon from "@/assets/redes-sociales/PINTEREST.png";
import { mapActions, mapGetters } from "vuex";
import tagFunctions from '@/utils/tagFunctions.js'
import Bowser from "bowser";

export default {
  name: "Menu",
  computed: {
    ...mapGetters(["getActiveSection"]),
  },
  methods: {
    ...mapActions({
      setActiveSection: "setActiveSection",
    }),
    socialClick(socialNetwork, action){
      tagFunctions.evSocialNetworkPush(socialNetwork, action)
      fbq('trackCustom', 'RedSocial'+socialNetwork);
    },
    socialGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
    headerGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
    openMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    selectHomeOption(option) {
      this.setActiveSection({
        willScroll: true,
        section: option,
      });
    },
    selectMobileOption(option) {
      this.setActiveSection({
        willScroll: true,
        section: option,
      });
      this.$router.push({ path: option }).catch(err => {
      // Ignore the vuex err regarding  navigating to the page they are already on.
      if (
        err.name !== 'NavigationDuplicated' &&
        !err.message.includes('Avoided redundant navigation to current location')
      ) {
        // But print any other errors to the console
        throw err;
      }
    });
      this.openMenu();
    },
    // selectMacarioOption(option) {
    //   this.getActiveSection = option;
    //   if (option === 'macario') {
    //     this.$router.push('/macario');
    //   }
    // },
  },
  data() {
    return {
      isMenuOpen: false,
      icon,
      carIconImage: carIcon,
      fbIconImage: fbIcon,
      twIconImage: twIcon,
      inIconImage: inIcon,
      pintImage: pintIcon,
      scrollingDown: false,
      isSafari: false,
    };
  },
  mounted() {
    var lastScrollTop = window.pageYOffset;
    window.addEventListener("scroll", () => { 
      var st = window.pageYOffset || document.documentElement.scrollTop; 
      if (st > lastScrollTop) {
        // downscroll code
        this.scrollingDown= true;
      } else {
        // upscroll code
        this.scrollingDown= false;
      }
      lastScrollTop = st <= 0 ? 0 : st; 
    }, false);
  },
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName() == 'Safari') {
      this.isSafari = true
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/Menu.scss";
</style>
